<template>
  <ValidationObserver v-slot="{ handleSubmit, invalid ,reset, errors}" ref="observer" slim>
    <b-tab :title-link-class="hasErrors(errors) ? 'has-error' : ''">
      <template v-slot:title>
        {{$t('Trust Levels')}}
        <span v-if="hasErrors(errors)" style="width: 20px;height: 20px" id="trust-level-exclamation-icon">
          <font-awesome-icon class="text-danger hover-cursor" icon="exclamation-circle"/>
        </span>
        <b-tooltip v-if="hasErrors(errors)" target="trust-level-exclamation-icon"
                   :title="$t('You have validation errors')"/>
      </template>
      <div class="outer-container">
        <div v-if="selectedBranch">
          <div class="row">
            <div class="col-md-12">
              <input-widget :model="model" attribute="enable_trust_levels" type="checkbox" :is-switch="true" :label="$t('Enable Trust Level Tiers')"/>
            </div>
            <div class="col-md-3">
              <input-widget :model="model" attribute="credit_limit_type" value-field="value" display-field="${item.key}"
                            type="select2" :items="creditLimitTypes"/>
            </div>
            <div class="col-md-3" v-if="model.credit_limit_type && !model.enable_trust_levels">
              <currency-input-widget :model="model" attribute="credit_limit" />
            </div>
          </div>
          <div class="row" v-if="model.credit_limit_type && model.enable_trust_levels">
            <div class="col-md-12">
              <div class="card">
                <div class="card-header d-flex align-items-center">
                  <h5 class="mb-0">
                    {{ $t('Trust Levels') }}
                  </h5>
                  <b-button class="ml-auto" variant="link" @click="addNewTrustLevel">
                    <font-awesome-icon :icon="'plus'" style="font-size: .9em"></font-awesome-icon>
                    {{ $t('New Trust Level') }}
                  </b-button>
                </div>
                <div class="card-body pt-0 pb-0">
                  <artisio-table
                      :items="selectedBranch.trust_levels ? selectedBranch.trust_levels : []"
                      :fields="tableFields">
                    <template slot="cell(name)" slot-scope="{item: trustLevel}">
                      {{ trustLevel.name }}
                      <action-buttons :view="false"
                                      @editClick="onEditClick(trustLevel)"
                                      @deleteClick="deleteTrustLevel(trustLevel)"/>
                    </template>
                    <template slot="cell(credit_limit)" slot-scope="{item: trustLevel}">
                      <span>{{trustLevel.credit_limit | asCurrency}}</span>
                    </template>
                    <template slot="cell(threshold)" slot-scope="{item: trustLevel}">
                      <span>{{trustLevel.threshold | asCurrency}}</span>
                    </template>
                    <template slot="cell(exclude_from_auto_assignment)" slot-scope="{item: trustLevel}">
                      <span v-if="trustLevel.exclude_from_auto_assignment" class="badge bg-success text-white">{{ $t('Yes') }}</span>
                      <span v-else class="badge bg-danger text-white">{{ $t('No') }}</span>
                    </template>
                  </artisio-table>
                </div>
              </div>
            </div>
          </div>
        </div>
        <no-data-available :height="5" v-if="!selectedBranch"/>
        <trust-level-tier-modal />
      </div>
    </b-tab>
  </ValidationObserver>
</template>

<script>
  import InputWidget from "../../../../../core/components/input-widget/InputWidget";
  import {createNamespacedHelpers} from "vuex";
  import NoDataAvailable from "../../../../../core/components/common/NoDataAvailable";
  import TrustLevelTierModal from "./TrustLevelTierModal";
  import TrustLevel from "./TrustLevel.model";
  import ArtisioTable from "../../../../../core/components/ams-table/ArtisioTable.vue";
  import ActionButtons from "../../../../../core/components/ams-table/ActionButtons.vue";
  import i18n from "../../../../../shared/i18n";
  import CurrencySelectInputWidget from "@/core/widgets/CurrencySelectInputWidget";
  import CurrencyInputWidget from "@/core/widgets/CurrencyInputWidget";

  const {mapState, mapActions, mapMutations} = createNamespacedHelpers('setup/branch');
  const {mapState: mapStateGlobal} = createNamespacedHelpers('global');
  export default {
    name: "TrustLevels",
    components: {
      CurrencyInputWidget,
      CurrencySelectInputWidget,
      ActionButtons, ArtisioTable, TrustLevelTierModal, NoDataAvailable, InputWidget},
    props: {
      model: {
        type: Object,
        required: true
      }
    },
    data() {
      return {
        tableFields: [
          {key: 'name', label: i18n.t('Name')},
          {key: 'credit_limit', label: i18n.t('Bidding Limit')},
          {key: 'threshold', label: i18n.t('Threshold')},
          {key: 'exclude_from_auto_assignment', label: i18n.t('Exclude from Auto Assignment')},
        ]
      };
    },
    computed: {
      ...mapState(['selectedBranch']),
      ...mapStateGlobal(['creditLimitTypes']),
    },
    methods: {
      ...mapActions(['removeTrustLevel']),
      ...mapMutations(['showTrustLevelModal']),
      hasErrors(errors) {
        for (let i in errors) {
          if (errors[i].length > 0) {
            return true;
          }
        }
        return false;
      },
      addNewTrustLevel() {
        this.showTrustLevelModal(new TrustLevel());
      },
      onEditClick(trustLevel) {
        this.showTrustLevelModal(new TrustLevel(trustLevel));
      },
      async deleteTrustLevel(trustLevel) {
          await this.$confirm(
              i18n.t("All existing customers with this tier will be assigned with corresponding one."),
              i18n.t('Trust Level has been successfully deleted'),
              this.removeTrustLevel,
              trustLevel
          );
      },
    },
  }
</script>

<style lang="scss" scoped>

</style>
